// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2BD4s","productName":"Table_productName__1ALKq"};